module.exports = __webpack_public_path__ + "img/arrow-method-payment-left.06c87fd0.svg";